var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ae-basic-from" },
    [
      _vm.isFba
        ? _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: !_vm.isEdit }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    width: "64px"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("FbaJob.ValueAddedServices")) + " "
                  )
                ]
              ),
              _c(
                "el-checkbox-group",
                {
                  attrs: { no: "selectedLocalAddedService" },
                  on: { change: _vm.addedServiceChangeHandler },
                  model: {
                    value: _vm.selectedLocalAddedService,
                    callback: function($$v) {
                      _vm.selectedLocalAddedService = $$v
                    },
                    expression: "selectedLocalAddedService"
                  }
                },
                _vm._l(_vm.localAddedService, function(item) {
                  return _c(
                    "el-checkbox",
                    {
                      key: item.code,
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: { label: item.code, no: "localAddedService" },
                      on: {
                        change: function(val) {
                          return _vm.singleAddedServiceChangeHandler(val, item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                  )
                }),
                1
              ),
              _vm.isAeBooking
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: {
                        "margin-left": "8px",
                        "margin-right": "8px"
                      },
                      attrs: { no: "destinationPortService" },
                      model: {
                        value: _vm.job.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "destinationPortService", $$v)
                        },
                        expression: "job.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "basicForm",
          staticStyle: { display: "flex" },
          attrs: {
            disabled: _vm.viewStatus,
            "label-position": "right",
            "label-width": "100px"
          }
        },
        [
          _c("div", { staticClass: "fit-content" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.JobNo") } },
                    [
                      _c("el-input", {
                        attrs: { no: "1", disabled: true },
                        model: {
                          value: _vm.job.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "jobNo", $$v)
                          },
                          expression: "job.jobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperateType") } },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.operateType
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "2",
                          clearable: false,
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_AirExportConstants$BUSINESS_MODELS,
                          "default-value": _vm.job.operateType,
                          disabled: !_vm.operateTypeEnable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.operateTypeChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isZY
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AllowSaleProduct,
                                filterable: "",
                                no: "allowSaleProduct",
                                clearable: "",
                                "data-filter-function": function(p) {
                                  if (!p.statusEnabled) {
                                    return false
                                  }
                                  return _vm.isFba
                                    ? p.fbaAir
                                    : p.airExportEnabled
                                },
                                "default-value": this.job.saleProductCode || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  this$1.job.saleProductCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_FullOrInside$FULL_OR_INSIDE,
                                no: "fullOrInside",
                                clearable: "",
                                "default-value": this.job.fullOrInside || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  this$1.job.fullOrInside = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ConsignationCompany")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sopImageB,
                                expression: "sopImageB"
                              }
                            ],
                            attrs: {
                              no: "3",
                              content: _vm.$t("SeaExport.SOPReceiver"),
                              placement: "right-end"
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "sop-img",
                              class:
                                _vm.job.customerId && _vm.viewStatus
                                  ? ""
                                  : "not-click",
                              staticStyle: {
                                padding: "5px 0",
                                "vertical-align": "bottom",
                                cursor: "pointer"
                              },
                              attrs: {
                                src: _vm.sopPic,
                                width: "18",
                                height: "28"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.sopChangeCustomerIdHandler()
                                }
                              }
                            })
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showWarningImageB,
                                expression: "showWarningImageB"
                              }
                            ],
                            attrs: {
                              content: _vm.warningImageBTip,
                              placement: "right-end"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning red",
                              staticStyle: { cursor: "pointer" }
                            })
                          ]
                        ),
                        !_vm.isFba
                          ? _c("cargo-sales-company-select", {
                              ref: "customerSelect",
                              staticClass: "shipper-selector",
                              class: _vm.importDifferenceField.customerId
                                ? "red-border"
                                : "",
                              style: {
                                width:
                                  _vm.showWarningImageB || _vm.sopImageB
                                    ? "180px"
                                    : "200px"
                              },
                              attrs: {
                                no: "4",
                                "popper-class": "shipper-selector-popper",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  customer: true,
                                  active: true,
                                  companyLob: "airExport"
                                },
                                "default-value": _vm.job.customerId || "",
                                "check-credit": true,
                                disabled: !_vm.customerEnabled,
                                placeholder: " ",
                                job: _vm.job
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.customerIdChange2ContractHandler(p)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.isFba
                          ? _c("cargo-company-select", {
                              ref: "customerSelect",
                              staticClass: "shipper-selector",
                              style: {
                                width:
                                  _vm.showWarningImageB || _vm.sopImageB
                                    ? "180px"
                                    : "200px"
                              },
                              attrs: {
                                no: "customerId",
                                "popper-class": "shipper-selector-popper",
                                "method-params": {
                                  customer: true,
                                  companyLob: "airExport",
                                  active: true,
                                  fba: true
                                },
                                "check-credit": true,
                                job: _vm.job,
                                "default-value": _vm.job.customerId || "",
                                disabled: !_vm.customerEnabled,
                                "data-filter-function": _vm.fbaCustomerIdFilter,
                                placeholder: " "
                              },
                              on: {
                                change: function(p) {
                                  _vm.customerIdChange2ContractHandler(p)
                                  _vm.clearPoNo()
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerProperty") } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.customerTip,
                            placement: "bottom"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customerLevel.customerName,
                                  expression: "customerLevel.customerName"
                                }
                              ],
                              staticStyle: { color: "#FD9A14" }
                            },
                            [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customerLevel.customerName,
                                  expression: "customerLevel.customerName"
                                }
                              ],
                              staticStyle: { color: "#D3A73B" }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.customerLevel.customerName)
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.contractStatusLabel,
                                  expression: "contractStatusLabel"
                                }
                              ],
                              staticStyle: { color: "red" }
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.contractStatusLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.advancePaymentLabel,
                                  expression: "advancePaymentLabel"
                                }
                              ],
                              staticStyle: { color: "firebrick" }
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.advancePaymentLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.stampPictureView.businessDocuments
                                      .length > 0,
                                  expression:
                                    "stampPictureView.businessDocuments.length > 0"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  _vm.stampPictureView.visible = true
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { "text-align": "right" },
                                attrs: {
                                  title: _vm.$t("Message.BookingSeal"),
                                  src: _vm.stampIcon,
                                  height: "14"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.dispatchingPlace
                          ? "red-border"
                          : "",
                        attrs: { no: "dispatchingPlace" },
                        model: {
                          value: _vm.job.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "dispatchingPlace", $$v)
                          },
                          expression: "job.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.LoadingPort")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "60px", "margin-right": "5px" },
                          attrs: {
                            no: "5",
                            value: _vm.loading3Code,
                            disabled: true
                          }
                        }),
                        _c("cargo-advance-select", {
                          ref: "loadingPortCode",
                          class: _vm.importDifferenceField.loadingPortCode
                            ? "red-border"
                            : "",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "6",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "default-value": _vm.job.loadingPortCode,
                            "tag-name": "englishName",
                            disabled: !!_vm.job.lclMasterUuid,
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.loadingPortCodeChange(p)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDestination")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "60px", "margin-right": "5px" },
                          attrs: {
                            no: "7",
                            value: _vm.destination3Code,
                            disabled: true
                          }
                        }),
                        _c("cargo-advance-select", {
                          class: _vm.importDifferenceField.destinationPortCode
                            ? "red-border"
                            : "",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "8",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "default-value": _vm.job.destinationPortCode,
                            disabled: !!_vm.job.lclMasterUuid,
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.destinationPortCodeChange(p)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.FinalPlaceOfDelivery") }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.destinationPlace
                              ? "red-border"
                              : "",
                            attrs: { no: "9" },
                            on: {
                              input: function(val) {
                                return _vm.pm.destinationPlaceChange(val)
                              }
                            },
                            model: {
                              value: _vm.job.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPlace", $$v)
                              },
                              expression: "job.destinationPlace"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Airline") } },
                    [
                      _c("el-input", {
                        attrs: { no: "10", disabled: true },
                        model: {
                          value: _vm.vesselLine,
                          callback: function($$v) {
                            _vm.vesselLine = $$v
                          },
                          expression: "vesselLine"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "11" },
                            model: {
                              value: _vm.job.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transfering", $$v)
                              },
                              expression: "job.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "12",
                              disabled:
                                _vm.viewStatus ||
                                (!_vm.viewStatus && !_vm.job.transfering),
                              type: "primary"
                            },
                            on: { click: _vm.setTransferingHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.EnterTransitInfo")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.cargoSource
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "13",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.local_cache_CargoSource,
                              "default-value": _vm.job.cargoSource,
                              fields: ["chineseName"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.cargoSourceChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ServiceProduct") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "145",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_AirServiceProduct,
                              "callback-method-type": "value",
                              "default-value": _vm.job.serviceProduct,
                              "callback-params": { key: "serviceProduct" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_AirlineProductCode")
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "airlineProductUuid",
                              filterable: "",
                              "static-options": _vm.airlineProductDownList,
                              "method-params": { active: true },
                              "tag-value": "uuid",
                              "tag-name": "name",
                              "filter-tag-names": ["name"],
                              "static-component": new _vm.AutoComplete(),
                              "callback-method-type": "value",
                              "default-value": _vm.job.airlineProductUuid,
                              "callback-params": { key: "airlineProductUuid" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "14",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          "method-params": { type: _vm.job.lob },
                          "default-value": _vm.job.customJobType,
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.customJobTypeList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customJobType = p.value
                            _vm.oncustomJobTypeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Information.AppraisalCategory") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "146",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AppraisalCategory,
                          "default-value": _vm.job.appraisalCategory,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.appraisalCategory = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.job.customJobType &&
                  _vm.secondaryCustomJobTypeList.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondaryCustomJobType",
                            attrs: {
                              no: "secondaryCustomJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              cache: false,
                              "default-value": _vm.job.secondaryCustomJobType,
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.secondaryCustomJobTypeList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.secondaryCustomJobType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.PortOfLoadingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.localAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "15",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { localAgent: true, active: true },
                          "default-value": _vm.job.localAgent || "",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.localAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DestinationAgent") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageC,
                                  expression: "showWarningImageC"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageCTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: { color: "red" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.destinationAgent
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "16",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                overseaAgent: true,
                                active: true
                              },
                              "default-value": _vm.job.destinationAgent || "",
                              "tag-name": "englishName",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.destinationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.job.cargoSource === "NC"
                    ? _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.sopImageA,
                                    expression: "sopImageA"
                                  }
                                ],
                                attrs: {
                                  no: "17",
                                  content: _vm.$t("SeaExport.SOPReceiver"),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("div", [
                                  _c("img", {
                                    staticClass: "sop-img",
                                    class:
                                      _vm.job.designationAgent && _vm.viewStatus
                                        ? ""
                                        : "not-click",
                                    staticStyle: {
                                      padding: "5px 0",
                                      cursor: "pointer"
                                    },
                                    attrs: {
                                      src: _vm.sopPic,
                                      width: "18",
                                      height: "28",
                                      no: "designationAgent"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.sopChangeBookingAgentHandler()
                                      }
                                    }
                                  })
                                ])
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showWarningImageA,
                                    expression: "showWarningImageA"
                                  }
                                ],
                                attrs: {
                                  content: _vm.warningImageATip,
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    color: "red",
                                    cursor: "pointer"
                                  }
                                })
                              ]
                            ),
                            _c("cargo-advance-select", {
                              staticClass: "designation-agent-selector",
                              class: _vm.importDifferenceField.designationAgent
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "18",
                                "popper-class":
                                  "designation-agent-selector-popper",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                disabled: !_vm.designationAgentEnabled,
                                "method-params": {
                                  designationAgent: true,
                                  active: true
                                },
                                "check-credit": true,
                                "default-value": _vm.job.designationAgent || "",
                                filterable: "",
                                headers: [_vm.$t("Partners.englishName")],
                                fields: ["englishName"],
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.designationAgentChangeHandler(p)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BillExchangeAgent") } },
                    [
                      _c("cargo-company-select", {
                        class: _vm.importDifferenceField.exChangeAgent
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "exChangeAgent",
                          disabled: !_vm.job.dischargingPortDoor,
                          "method-params": { bookingAgent: true, active: true },
                          "default-value": _vm.job.exChangeAgent || ""
                        },
                        on: { change: _vm.onExChangeAgentChange }
                      })
                    ],
                    1
                  ),
                  _vm.bookingAgentVisible
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                        [
                          _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.bookingAgent
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "19",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                bookingAgent: true,
                                active: true
                              },
                              "default-value": _vm.job.bookingAgent || "",
                              disabled: !_vm.bookingAgentEnabled,
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.bookingAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                    [
                      _c("el-date-picker", {
                        ref: "fileCutoff",
                        class: _vm.importDifferenceField.fileCutoff
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "20",
                          disabled: !!_vm.job.lclMasterUuid,
                          clearable: "",
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "fileCutoff",
                              null,
                              true,
                              false,
                              _vm.job
                            )
                          }
                        },
                        model: {
                          value: _vm.job.fileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "fileCutoff", $$v)
                          },
                          expression: "job.fileCutoff"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.MasterBillNo") } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-right": "2px" },
                          attrs: { no: "122" },
                          on: { change: _vm.expressChangeHandler },
                          model: {
                            value: _vm.job.express,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "express", $$v)
                            },
                            expression: "job.express"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
                      ),
                      _vm.job.express
                        ? _c("el-input", {
                            staticStyle: { width: "130px" },
                            attrs: { no: "21" },
                            on: { change: _vm.mblChange },
                            model: {
                              value: _vm.job.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "mbl", $$v)
                              },
                              expression: "job.mbl"
                            }
                          })
                        : _vm._e(),
                      _c("mawb-no-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.job.express,
                            expression: "!job.express"
                          }
                        ],
                        ref: "mawbNoInput",
                        attrs: {
                          no: "22",
                          editable: _vm.isEditablemawbNoInput
                        },
                        on: {
                          change: _vm.mblChangeEvent,
                          changeCallback: function($event) {
                            return _vm.mblCheckHandler(true)
                          }
                        },
                        model: {
                          value: _vm.job.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "mbl", $$v)
                          },
                          expression: "job.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "23",
                            disabled: !_vm.propertiesEnabled.selectBtnEnabled,
                            type: "primary"
                          },
                          on: { click: _vm.openMAWBHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Select")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "24",
                            disabled: !_vm.propertiesEnabled
                              .newConsoleBtnEnabled,
                            type: "primary"
                          },
                          on: { click: _vm.newConsoleHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.New")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "25",
                            disabled: !_vm.propertiesEnabled.attachBtnEnabled,
                            type: "primary"
                          },
                          on: { click: _vm.attachMAWBHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "26",
                            disabled: !_vm.propertiesEnabled.deattachBtnEnabled,
                            type: "primary"
                          },
                          on: { click: _vm.deattachMAWBHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Separate")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                    [
                      _c("so-no-input", {
                        attrs: { no: "27", disabled: _vm.viewStatus },
                        model: {
                          value: _vm.job.jobSoNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "jobSoNo", $$v)
                          },
                          expression: "job.jobSoNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "28" },
                          model: {
                            value: _vm.job.predictionOperation,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "predictionOperation", $$v)
                            },
                            expression: "job.predictionOperation"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.PreAlertOperation")))]
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  !_vm.isFba && !_vm.isAeBooking
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "dischargingPortDoor" },
                              model: {
                                value: _vm.job.dischargingPortDoor,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                                },
                                expression: "job.dischargingPortDoor"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DispatchVehiclesAtDestination"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "usCustomsClearance" },
                              model: {
                                value: _vm.job.usCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "usCustomsClearance", $$v)
                                },
                                expression: "job.usCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.UsCustomsClearance")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "destPortCustomsClearance" },
                              model: {
                                value: _vm.job.destPortCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "destPortCustomsClearance",
                                    $$v
                                  )
                                },
                                expression: "job.destPortCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.PortOfDestinationCustomsClearance"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ContactPerson"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              class: _vm.importDifferenceField.customerContact
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "29",
                                filterable: "",
                                "allow-create": true,
                                placeholder: " "
                              },
                              model: {
                                value: _vm.job.customerContact,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customerContact", $$v)
                                },
                                expression: "job.customerContact"
                              }
                            },
                            _vm._l(_vm.contactList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.contactPerson,
                                  value: item.contactPerson
                                }
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-link",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowContactPersonDetail,
                                  expression: "!isShowContactPersonDetail"
                                }
                              ],
                              staticStyle: { width: "80px" },
                              attrs: { no: "30" },
                              on: {
                                click: function($event) {
                                  _vm.showContactsInfoDialog = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowContactPersonDetail,
                          expression: "!isShowContactPersonDetail"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("SeaExport.Tel"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.contactTelephone
                          ? "red-border"
                          : "",
                        attrs: { no: "31" },
                        model: {
                          value: _vm.job.contactTelephone,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "contactTelephone", $$v)
                          },
                          expression: "job.contactTelephone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowContactPersonDetail,
                          expression: "!isShowContactPersonDetail"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("SeaExport.Fax"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.contactFax
                          ? "red-border"
                          : "",
                        attrs: { no: "32" },
                        model: {
                          value: _vm.job.contactFax,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "contactFax", $$v)
                          },
                          expression: "job.contactFax"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ArrivalMethod"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        ref: "loadingTerm",
                        class: _vm.importDifferenceField.loadingTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "33",
                          clearable: false,
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_AirExportConstants$SUFFY_TYPES,
                          "callback-method-type": "value",
                          "default-value": _vm.job.loadingTerm,
                          fields: ["chineseName"],
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          "callback-params": { key: "loadingTerm" },
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  !_vm.isFba && _vm.isAeBooking
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "dischargingPortDoor" },
                              on: { change: _vm.dischargingPortDoorClick },
                              model: {
                                value: _vm.job.dischargingPortDoor,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                                },
                                expression: "job.dischargingPortDoor"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DispatchVehiclesAtDestination"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "usCustomsClearance" },
                              model: {
                                value: _vm.job.usCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "usCustomsClearance", $$v)
                                },
                                expression: "job.usCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.UsCustomsClearance")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "destPortCustomsClearance" },
                              model: {
                                value: _vm.job.destPortCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "destPortCustomsClearance",
                                    $$v
                                  )
                                },
                                expression: "job.destPortCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.PortOfDestinationCustomsClearance"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba && _vm.isAeBooking && _vm.job.destinationPortService
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { no: "123" },
                              on: { change: _vm.addedServiceChangeHandler },
                              model: {
                                value: _vm.selectedPodAddedService,
                                callback: function($$v) {
                                  _vm.selectedPodAddedService = $$v
                                },
                                expression: "selectedPodAddedService"
                              }
                            },
                            _vm._l(_vm.podAddedService, function(item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.code,
                                  staticStyle: { display: "block" },
                                  attrs: { label: item.code, no: "124" },
                                  on: {
                                    change: function(val) {
                                      return _vm.singleAddedServiceChangeHandler(
                                        val,
                                        item
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.quotationNum"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "34",
                          value: _vm.job.quotationNo,
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.BookingProperty"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.bookingTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "35",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.local_cache_BookingTerm,
                          "default-value": _vm.job.bookingTerm,
                          disabled: !_vm.propertiesEnabled.bookingTermEnabled,
                          fields: ["chineseName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.bookingTermChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationMethod"),
                        "label-width": "120px"
                      }
                    },
                    [
                      !_vm.isFba
                        ? _c("cargo-advance-select", {
                            class: _vm.importDifferenceField.customClaim
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "36",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 2 },
                              "tag-value": "serialNum",
                              filterable: "",
                              "default-value": _vm.job.customClaim
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customClaim = p.value
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.isFba
                        ? _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPol",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 0 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPol
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPol = p.value
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("AirExport.CustomsClearanceMethod"),
                            "label-width": "120px"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsMethodPod",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CustomsMode,
                              "method-params": { serviceType: 1 },
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.fbaJob.customsMethodPod
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.fbaJob.customsMethodPod = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  Number(_vm.job.customClaim) === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationType"),
                            "label-width": "120px"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "37",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_CustomsDeclarationType,
                              "default-value": _vm.job.customsClaim2 || 0
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customsClaim2 = p.value
                                _vm.job.customsDeclarationType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.TradeMethod"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.tradeTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "38",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.job.tradeTerm,
                          "callback-params": { key: "tradeTerm" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.StatusOfCustomsDeclaration"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.declareCustomsState
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "39",
                          filterable: "",
                          disabled: false,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$DECLARE_CUSTOMS_STATE,
                          "default-value": _vm.job.declareCustomsState || "",
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          fields: ["chineseName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.declareCustomsState = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.TradeTerms2"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.incoTerm
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "40",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.job.incoTerm,
                          "callback-params": { key: "incoTerm" },
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.AirlineCompany"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.carrierId
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "41",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            airCmp: true,
                            companyLob: "airExport",
                            active: true
                          },
                          "default-value": _vm.job.carrierId || "",
                          headers: [
                            _vm.$t("Tool.ShortName"),
                            _vm.$t("Partners.chineseName")
                          ],
                          fields: ["shortName", "chineseName"],
                          disabled: !_vm.airlineCompanyEnabled,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.airlineCompanyChangeHandler(p.value || 0)
                            _vm.pm.airlineCompanyChange(p.value || 0)
                            _vm.airlineCompanyCheckHandler(p.value || 0)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.Flight"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.voyageFlight
                          ? "red-border"
                          : "",
                        attrs: { no: "42", disabled: !_vm.flightEnabled },
                        on: { change: _vm.voyageFlightCheckHandler },
                        model: {
                          value: _vm.job.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "voyageFlight", $$v)
                          },
                          expression: "job.voyageFlight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OperationDate"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("el-date-picker", {
                        class: _vm.importDifferenceField.customsDate
                          ? "red-border"
                          : "",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "43",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "customsDate", $$v)
                          },
                          expression: "job.customsDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { "label-width": "120px" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          ref: "etd",
                          class: _vm.importDifferenceField.etd
                            ? "red-border"
                            : "",
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            value: _vm.job.etd,
                            no: "44",
                            disabled:
                              !!_vm.job.lclMasterUuid || _vm.provisionEtdLocked,
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm",
                            format: "yyyy-MM-dd HH:mm",
                            clearable: ""
                          },
                          on: {
                            input: _vm.etdChange,
                            blur: function() {
                              _vm.handleBlur(
                                "etd",
                                _vm.etdChange,
                                false,
                                false,
                                _vm.job
                              )
                            }
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.sailingDay))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm.provisionEtdLocked
                      ? _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-size": "12px" }
                          },
                          [_vm._v("(已计提校准不可修改)")]
                        )
                      : _vm._e()
                  ]),
                  _c("el-form-item", { attrs: { "label-width": "120px" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          ref: "eta",
                          class: _vm.importDifferenceField.eta
                            ? "red-border"
                            : "",
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "45",
                            disabled: !!_vm.job.lclMasterUuid,
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm",
                            format: "yyyy-MM-dd HH:mm",
                            clearable: ""
                          },
                          on: {
                            input: _vm.etaChange,
                            blur: function() {
                              _vm.handleBlur(
                                "eta",
                                _vm.etaChange,
                                false,
                                false,
                                _vm.job
                              )
                            }
                          },
                          model: {
                            value: _vm.job.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "eta", $$v)
                            },
                            expression: "job.eta"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.etaSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", { attrs: { "label-width": "120px" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.ActualDateOfDeparture2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          ref: "atd",
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            value: _vm.job.atd,
                            no: "46",
                            disabled: !!_vm.job.lclMasterUuid,
                            clearable: "",
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            input: _vm.atdChange,
                            blur: function() {
                              _vm.handleBlur(
                                "atd",
                                _vm.atdChange,
                                false,
                                false,
                                _vm.job
                              )
                            }
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.atdSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", { attrs: { "label-width": "120px" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.ActualDateOfArrival2")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          ref: "ata",
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            no: "47",
                            disabled: !!_vm.job.lclMasterUuid,
                            clearable: "",
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            input: _vm.ataChange,
                            blur: function() {
                              _vm.handleBlur(
                                "ata",
                                _vm.ataChange,
                                false,
                                false,
                                _vm.job
                              )
                            }
                          },
                          model: {
                            value: _vm.job.ata,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "ata", $$v)
                            },
                            expression: "job.ata"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.ataSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CategoryOfGoods"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.cargoCode
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "48",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoInformation,
                          filterable: "",
                          "callback-params": { key: "cargoCode" },
                          "default-value": _vm.job.cargoCode,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: _vm.txtCargoInformationChangeHandler
                        }
                      }),
                      _c("el-input", {
                        class: _vm.importDifferenceField.cargoName
                          ? "red-border"
                          : "",
                        attrs: { disabled: !_vm.job.cargoCode },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TransportSource"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          no: "transportSource",
                          "default-value": _vm.job.transportSource,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.job.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ServiceStatisticalArea"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          no: "statisticArea",
                          "default-value": _vm.job.statisticArea,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.job.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.Package"),
                            "label-width": "120px"
                          }
                        },
                        [
                          _c("cargo-packing-select", {
                            attrs: {
                              no: "packing",
                              "default-value": _vm.job.packing,
                              "callback-params": {},
                              placeholder: " "
                            },
                            on: {
                              change: function(p) {
                                p.key = "packing"
                                _vm.setJobSelectValue(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.HsCode"),
                            "label-width": "120px"
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.hsCode
                              ? "red-border"
                              : "",
                            attrs: { no: "hsCode" },
                            model: {
                              value: _vm.job.hsCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "hsCode", $$v)
                              },
                              expression: "job.hsCode"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isFba
                    ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-around"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: {
                                  "margin-right": "10px",
                                  "margin-left": "20px"
                                },
                                attrs: { no: "125" },
                                model: {
                                  value: _vm.fbaJob.electric,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "electric", $$v)
                                  },
                                  expression: "fbaJob.electric"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("AirExport.WithBattery")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: { no: "126" },
                                model: {
                                  value: _vm.fbaJob.magnetic,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "magnetic", $$v)
                                  },
                                  expression: "fbaJob.magnetic"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("AirExport.WithMagnet")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: { no: "127" },
                                model: {
                                  value: _vm.fbaJob.powdery,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "powdery", $$v)
                                  },
                                  expression: "fbaJob.powdery"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("AirExport.Powder")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: { no: "128" },
                                model: {
                                  value: _vm.fbaJob.liquid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "liquid", $$v)
                                  },
                                  expression: "fbaJob.liquid"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("AirExport.Liquid")))]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  !_vm.job.lclMasterUuid && _vm.job.operateType !== 0
                    ? _c("booking-air-uld-data-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm.airUlds,
                          "is-edit": _vm.isEdit,
                          job: _vm.job
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c("el-form-item", { attrs: { label: "" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        !_vm.isFba
                          ? _c(
                              "el-checkbox",
                              {
                                attrs: { no: "49" },
                                model: {
                                  value: _vm.job.virtualHBL,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "virtualHBL", $$v)
                                  },
                                  expression: "job.virtualHBL"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FormalHbl")))]
                            )
                          : _vm._e(),
                        !_vm.isFba
                          ? _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "-20px" },
                                attrs: { no: "50" },
                                model: {
                                  value: _vm.job.itmService,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "itmService", $$v)
                                  },
                                  expression: "job.itmService"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
                            )
                          : _vm._e(),
                        _vm.viewSource === "AeBooking"
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_insurance_toInsure"],
                                    expression: "['button_insurance_toInsure']"
                                  }
                                ],
                                class: _vm.viewStatus
                                  ? "el-button el-button--primary el-button--mini"
                                  : "el-button el-button--primary el-button--mini is-disabled",
                                staticStyle: {
                                  "min-width": "46px!important",
                                  "margin-left": "15px"
                                },
                                attrs: {
                                  id: "Insure",
                                  type: "primary",
                                  no: "129"
                                },
                                on: {
                                  click: function() {
                                    if (_vm.viewStatus) {
                                      _vm.pm.toInsure()
                                    }
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")) + " ")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WarehouseNo") } },
                    [
                      _c("el-input", {
                        attrs: { no: "52", type: "textarea", rows: 5 },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showWarehouseDialog($event)
                          }
                        },
                        model: {
                          value: _vm.job.warehouseNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "warehouseNo", $$v)
                          },
                          expression: "job.warehouseNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "CargoMsg.Cargo_FrontEndWarehouseOperation"
                        )
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "frontEndWarehouseOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": {
                            dataType: 1,
                            deletionFlag: false,
                            orderType: _vm.SystemConstants.AE.code
                          },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.frontEndWarehouseOperation
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.frontEndWarehouseOperation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Warehouse.WarehouseInState"),
                        no: "WarehouseState"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: true,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "130"
                          },
                          model: {
                            value: _vm.job.warehouseStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "warehouseStatus", $$v)
                            },
                            expression: "job.warehouseStatus"
                          }
                        },
                        _vm._l(_vm.WarehouseInState.WAREHOUSE_STATE, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_EstimatedWarehousingTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        ref: "estimatedDateOfWarehousinge",
                        class: _vm.importDifferenceField
                          .estimatedDateOfWarehousinge
                          ? "red-border"
                          : "",
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "131"
                        },
                        on: {
                          change: _vm.changeEstimatedDateOfWarehousinge,
                          blur: function() {
                            _vm.handleBlur(
                              "estimatedDateOfWarehousinge",
                              _vm.changeEstimatedDateOfWarehousinge,
                              true,
                              true,
                              _vm.job
                            )
                          }
                        },
                        model: {
                          value: _vm.job.estimatedDateOfWarehousinge,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.job,
                              "estimatedDateOfWarehousinge",
                              $$v
                            )
                          },
                          expression: "job.estimatedDateOfWarehousinge"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ActualWarehousingTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          disabled: true,
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_SyncWarehouseData"
                          ),
                          value: _vm.job.warehouseInDate,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "132"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_EstimatedDeliveryTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        ref: "estimatedDeliveryTime",
                        class: _vm.importDifferenceField.estimatedDeliveryTime
                          ? "red-border"
                          : "",
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "133"
                        },
                        on: {
                          change: _vm.changeEstimatedDeliveryTime,
                          blur: function() {
                            _vm.handleBlur(
                              "estimatedDeliveryTime",
                              _vm.changeEstimatedDeliveryTime,
                              true,
                              true,
                              _vm.job
                            )
                          }
                        },
                        model: {
                          value: _vm.job.estimatedDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimatedDeliveryTime", $$v)
                          },
                          expression: "job.estimatedDeliveryTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ActualDeliveryTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetime",
                          disabled: true,
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_SyncWarehouseData"
                          ),
                          value: _vm.job.warehouseOutDate,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          clearable: "",
                          no: "134"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CargoTerminalOperation")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoTerminalOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": { dataType: 0, deletionFlag: false },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoTerminalOperation
                        },
                        on: {
                          parentCallBack: function(p) {
                            return _vm.cargoTerminalOperationChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_EstimatedDeliveryDate")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          disabled:
                            !_vm.isEdit || !_vm.job.cargoTerminalOperation,
                          no: "estimatedDeliveryDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.estimatedDeliveryDate,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimatedDeliveryDate", $$v)
                          },
                          expression: "job.estimatedDeliveryDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomerReferenceNumber")
                      }
                    },
                    [
                      _c("cargo-input", {
                        attrs: { no: "53", trim: true },
                        model: {
                          value: _vm.job.customerRefNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "customerRefNo", $$v)
                          },
                          expression: "job.customerRefNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.FirstLegNo"),
                        title: _vm.$t("SeaExport.FirstLegNoTips")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "54" },
                        model: {
                          value: _vm.job.relatedJob2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "relatedJob2", $$v)
                          },
                          expression: "job.relatedJob2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "KC No" } },
                    [
                      _c("el-input", {
                        attrs: { no: "55" },
                        model: {
                          value: _vm.job.kcNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "kcNo", $$v)
                          },
                          expression: "job.kcNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "poNoClass" : "",
                      attrs: { label: _vm.$t("SeaExport.ItemNo") }
                    },
                    [
                      !_vm.openProjectConfig
                        ? _c("el-input", {
                            attrs: { no: "56" },
                            model: {
                              value: _vm.job.poNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "poNo", $$v)
                              },
                              expression: "job.poNo"
                            }
                          })
                        : _vm._e(),
                      _vm.openProjectConfig
                        ? _c("cargo-project-select", {
                            attrs: {
                              no: "57",
                              "default-value": _vm.job.poNo,
                              "customer-id": _vm.job.customerId,
                              "is-linked": _vm.isProjectLinkedCustomer,
                              placeholder: " "
                            },
                            on: {
                              change: function(p) {
                                _vm.job.poNo = p.value
                                _vm.job.projectName = p.projectName
                                _vm.changeProject()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectName") } },
                        [
                          _c("el-input", {
                            attrs: { no: "58", disabled: true },
                            model: {
                              value: _vm.job.projectName,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "projectName", $$v)
                              },
                              expression: "job.projectName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectBatch") } },
                        [
                          _c("el-input", {
                            attrs: { no: "59" },
                            model: {
                              value: _vm.job.projectBatch,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "projectBatch", $$v)
                              },
                              expression: "job.projectBatch"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.MasterBLFreightTerm") }
                    },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.paymentTermMBL
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "60",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.paymentTermMBLChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HBLFreightClause") } },
                    [
                      _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.paymentTermHBL
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "61",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          "default-value": _vm.job.paymentTermHBL,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.paymentTermHBLChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SpaceRquirement") } },
                    [
                      _c("el-input", {
                        attrs: { no: "62" },
                        model: {
                          value: _vm.job.cabinReq,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cabinReq", $$v)
                          },
                          expression: "job.cabinReq"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.OnBoardRequirements") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "63" },
                        model: {
                          value: _vm.job.loadReq,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "loadReq", $$v)
                          },
                          expression: "job.loadReq"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.DocumentationRequirements")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "64" },
                        model: {
                          value: _vm.job.docReq,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "docReq", $$v)
                          },
                          expression: "job.docReq"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c(
                        "el-select",
                        {
                          class: _vm.importDifferenceField.cargoType
                            ? "red-border"
                            : "",
                          attrs: { filterable: "", no: "135" },
                          on: { change: _vm.onCargoTypeChagne },
                          model: {
                            value: _vm.job.cargoType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoType", $$v)
                            },
                            expression: "job.cargoType"
                          }
                        },
                        _vm._l(_vm.cargoType4JobSelect, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OrderChannels") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "136" },
                        model: {
                          value: _vm.job.salesChannel,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "salesChannel", $$v)
                          },
                          expression: "job.salesChannel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ConsignationRelationNumber")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "trustFromJob" },
                        model: {
                          value: _vm.job.trustFromJob,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "trustFromJob", $$v)
                          },
                          expression: "job.trustFromJob"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "SeaExport.BusinessCommissionedRelationNumber"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "relatedJob" },
                        model: {
                          value: _vm.job.relatedJob,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "relatedJob", $$v)
                          },
                          expression: "job.relatedJob"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.showChannelNo
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ChannelNo") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "137" },
                            model: {
                              value: _vm.job.channelNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "channelNo", $$v)
                              },
                              expression: "job.channelNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoSize") } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "GetGoodsInformation",
                            disabled: !_vm.isEdit,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.pm.getCargoInformation()
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.GetGoodsInformation")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            content: _vm.$t("SeaExport.GetGoodsInformationTip"),
                            placement: "right-end",
                            disabled: ""
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              cursor: "pointer",
                              "margin-left": "4px",
                              color: "#1989fa"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "auto-width", attrs: { label: "" } },
                    [
                      _c("el-input", {
                        attrs: { no: "66", type: "textarea", rows: 3 },
                        on: {
                          change: function(p) {
                            _vm.pm.measurementsChangeHandler(p)
                          }
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.CargoSize"),
                              _vm.job.measurements,
                              function(val) {
                                _vm.pm.doMeasurementsChangeHandler(val)
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.measurements,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "measurements", $$v)
                          },
                          expression: "job.measurements"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SellingPrice") } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.job.sellingPriceLock || !_vm.isEdit,
                          no: "67"
                        },
                        on: { blur: _vm.sellingOrBuyingChangeHandler },
                        model: {
                          value: _vm.job.selling,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "selling", $$v)
                          },
                          expression: "job.selling"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BuyingPrice") } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.job.purchasePriceLock || !_vm.isEdit,
                          no: "68"
                        },
                        on: { blur: _vm.sellingOrBuyingChangeHandler },
                        model: {
                          value: _vm.job.buying,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "buying", $$v)
                          },
                          expression: "job.buying"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ProtocolType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "69",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$PROTOCOL_TYPES,
                          "callback-method-type": "value",
                          "default-value": _vm.job.protocolType || "none",
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          fields: ["chineseName"],
                          "callback-params": { key: "protocolType" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OperationRequirements")
                      }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.job.operationContent,
                            placement: "left"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.job.operationContent
                                  ? _vm.job.operationContent.replace(
                                      /[\n]/g,
                                      "</br>"
                                    )
                                  : _vm.$t("SeaExport.NoData")
                              )
                            },
                            slot: "content"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "70",
                              value: _vm.job.operationContent,
                              placeholder: _vm.viewStatus
                                ? ""
                                : _vm.$t(
                                    "SeaExport.DoubleClickToAddOperationRequirements"
                                  ),
                              type: "textarea",
                              rows: 4
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.selectOperationReqDialog.value =
                                  _vm.job.operationContent
                                _vm.selectOperationReqDialog.visible = !_vm.viewStatus
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WoodOrNotWood") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "147",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_AirExportConstants$WOOD,
                              "default-value": _vm.job.wood,
                              fields: ["chineseName"]
                            },
                            on: { parentCallBack: _vm.onWoodOrNotWoodChagne }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.HazardousGoodsOption") }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "148",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_AirExportConstants$HAZARDOUS_GOODS_OPTION,
                              "default-value": _vm.job.hazardousGoodsOption,
                              fields: ["chineseName"]
                            },
                            on: {
                              parentCallBack: _vm.onHazardousGoodsOptionChagne
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.handlingInformation") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "149",
                          readonly: true,
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.handlingInformation"),
                              _vm.job.handlingInformation,
                              function(val) {
                                _vm.job.handlingInformation = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.handlingInformation,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "handlingInformation", $$v)
                          },
                          expression: "job.handlingInformation"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isFba
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OperationTips") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "operationTips",
                              type: "textarea",
                              rows: 5
                            },
                            model: {
                              value: _vm.job.operationTips,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "operationTips", $$v)
                              },
                              expression: "job.operationTips"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesCompany") } },
                    [
                      _c("el-input", {
                        class: _vm.importDifferenceField.salesOffice
                          ? "red-border"
                          : "",
                        attrs: { no: "71", disabled: true },
                        model: {
                          value: _vm.txtSalesOffice,
                          callback: function($$v) {
                            _vm.txtSalesOffice = $$v
                          },
                          expression: "txtSalesOffice"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        class: _vm.job.cargoSource === "NC" ? "" : "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "sales",
                          class: _vm.importDifferenceField.sales
                            ? "red-border"
                            : "",
                          staticStyle: { width: "130px", flex: "1" },
                          attrs: {
                            no: "72",
                            disabled: !_vm.saleEnabled,
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales",
                              active: true
                            },
                            "default-value": _vm.job.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.salesPrompt || " "
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.salesChangeHandler(p)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { no: "73", disabled: true },
                            model: {
                              value: _vm.job.provisioned,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "provisioned", $$v)
                              },
                              expression: "job.provisioned"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.cargoSalesId
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "74",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.job.cargoSalesId || "",
                          placeholder: " ",
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.job.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          class: _vm.job.cargoSource === "NC" ? "" : "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.SalesDepartment")))]
                      ),
                      _c("cargo-department-new-select", {
                        class: _vm.importDifferenceField.salesDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "75",
                          disabled: !_vm.job.sales,
                          enables: true,
                          "sales-id": Number(_vm.job.sales),
                          "office-id": Number(_vm.job.salesOffice),
                          "department-id": Number(_vm.job.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.departmentChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.opOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "76",
                          disabled: _vm.viewStatus || _vm.opOfficeDisabled,
                          "office-id": Number(_vm.job.opOffice),
                          placeholder: " ",
                          "is-regional-commission": _vm.isRegionalCommission
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.opOfficeChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.opDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "77",
                          disabled: !_vm.opDeptEnabled,
                          enables: true,
                          "office-id": Number(_vm.job.opOffice),
                          "department-id": Number(_vm.job.opDepartment),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          class:
                            _vm.pageSource === "AeBookingVerify" ? "" : "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                      ),
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.op ? "red-border" : "",
                        attrs: {
                          no: "78",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || "",
                          "static-options": _vm.userPortRoleData.op,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.csrOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrOffice = p.value
                            _vm.job.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("Message.Customer_Service")))
                      ]),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.csrDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.job.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.job.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.csr
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "79",
                          "method-params": { category: "role", shape: "csr" },
                          "default-value": _vm.job.csr || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.csr
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.dcOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcOffice = p.value
                            _vm.job.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Message.Documentation_Department"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.dcDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.job.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.job.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.dc ? "red-border" : "",
                        attrs: {
                          no: "80",
                          "method-params": { category: "role", shape: "doc" },
                          "default-value": _vm.job.dc || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.doc
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                    [
                      _c("cargo-office-select", {
                        class: _vm.importDifferenceField.plannerOffice
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerOffice = p.value
                            _vm.job.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.AirlineDepartment")))
                      ]),
                      _c("cargo-department-select", {
                        class: _vm.importDifferenceField.plannerDepartment
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.job.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.job.plannerDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                    [
                      _c("cargo-user-select", {
                        class: _vm.importDifferenceField.planner
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "81",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "airline"
                          },
                          "default-value": _vm.job.planner || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.airline
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.plannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "82",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.job.siteOP || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.siteOp
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.siteOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "overseaOp",
                        attrs: {
                          no: "83",
                          "default-value": _vm.job.overseaOp || "",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "static-options": _vm.isHC
                            ? null
                            : _vm.userPortRoleData.overseaOp ||
                              _vm.overseaAgentUsersList,
                          "merge-load": true,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.overseaOp = p.value
                            _vm.pm.overseaOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          disabled: _vm.viewStatus,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || "",
                          "merge-load": true,
                          placeholder: " ",
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole1
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          disabled: _vm.viewStatus,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || "",
                          "merge-load": true,
                          placeholder: " ",
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole2
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("special-requests-grid", {
                        attrs: {
                          no: "satisfiedRequests",
                          "customer-id": _vm.job.customerId,
                          lob: _vm.job.lob,
                          job: _vm.job,
                          "is-edit": !_vm.viewStatus
                        },
                        model: {
                          value: _vm.job.satisfiedRequests,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "satisfiedRequests", $$v)
                          },
                          expression: "job.satisfiedRequests"
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isFba
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-top": "10px" },
                          attrs: { label: _vm.$t("SeaExport.HsCode") }
                        },
                        [
                          _c("el-input", {
                            class: _vm.importDifferenceField.hsCode
                              ? "red-border"
                              : "",
                            attrs: { no: "84" },
                            model: {
                              value: _vm.job.hsCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "hsCode", $$v)
                              },
                              expression: "job.hsCode"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "85", type: "textarea", rows: 5 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.job.remarks,
                              function(val) {
                                _vm.job.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.isFba
                ? _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            disabled: _vm.viewStatus,
                            "label-width": "120px",
                            "label-position": "right"
                          }
                        },
                        [
                          !_vm.isEdit
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.ServiceChannel")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "serviceChannel",
                                      disabled: "",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_FbaChannel,
                                      filterable: "",
                                      "method-params": {
                                        shippingType: _vm.fbaJob.shippingType,
                                        active: true
                                      },
                                      clearable: true,
                                      "default-value": _vm.fbaJob.serviceChannel
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.fbaJob.serviceChannel = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isEdit
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.ServiceChannel")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        no: "138"
                                      },
                                      on: { change: _vm.changeServiceChannel },
                                      model: {
                                        value: _vm.fbaJob.serviceChannel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "serviceChannel",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.serviceChannel"
                                      }
                                    },
                                    _vm._l(_vm.channel4JobSelect, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.channelName,
                                          value: item.channelName
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "AirExport.EstimatedStorageGoodArrivalTime"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preWarehousingTime",
                                  type: "datetime",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                on: { change: _vm.preWarehousingChangeHandler },
                                model: {
                                  value: _vm.fbaJob.preWarehousingTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "preWarehousingTime",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.preWarehousingTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.ExpectedTimeIntoAmazonWarehouse"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preAmazonWhTime",
                                  disabled: _vm.viewStatus,
                                  type: "date",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.fbaJob.preAmazonWhTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "preAmazonWhTime", $$v)
                                  },
                                  expression: "fbaJob.preAmazonWhTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-form-item", [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Destination"))
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex", flex: "1" } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.fbaJob.warehouseCode,
                                      placement: "bottom-end"
                                    }
                                  },
                                  [
                                    _c("el-cascader", {
                                      staticStyle: { "padding-right": "2px" },
                                      attrs: {
                                        options: _vm.destinations,
                                        filterable: "",
                                        clearable: true,
                                        no: "139"
                                      },
                                      on: {
                                        focus: function($event) {
                                          return _vm.JobUtils.focusWarehouseCode(
                                            _vm.fbaJob
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.JobUtils.blurWarehouseCode(
                                            _vm.fbaJob
                                          )
                                        },
                                        change: function(p) {
                                          _vm.JobUtils.warehouseCodeHandler(
                                            _vm.fbaJob,
                                            p
                                          )
                                          _vm.changeWarehouseCode
                                        }
                                      },
                                      model: {
                                        value: _vm.fbaJob.warehouseCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "warehouseCode",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.warehouseCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "remoteWarehouse" },
                                    model: {
                                      value: _vm.fbaJob.remoteWarehouse,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fbaJob,
                                          "remoteWarehouse",
                                          $$v
                                        )
                                      },
                                      expression: "fbaJob.remoteWarehouse"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("AirExport.RemoteWarehouse")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Warehouse.DestinationCountry")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "country" },
                                model: {
                                  value: _vm.fbaJob.country,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "country", $$v)
                                  },
                                  expression: "fbaJob.country"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("AirExport.ZipCode") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "zipCode" },
                                model: {
                                  value: _vm.fbaJob.zipCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "zipCode", $$v)
                                  },
                                  expression: "fbaJob.zipCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.DestinationDeliveryMethod"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "destinationDistribution",
                                    filterable: ""
                                  },
                                  on: {
                                    change: _vm.destinationDistributionChange
                                  },
                                  model: {
                                    value: _vm.fbaJob.destinationDistribution,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "destinationDistribution",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.destinationDistribution"
                                  }
                                },
                                _vm._l(
                                  _vm.FbaJobConstants
                                    .ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _vm.fbaJob.destinationDistribution &&
                          Number(_vm.fbaJob.destinationDistribution) === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.CourierCompany")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "expressCompany",
                                        placeholder: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.fbaJob.expressCompany,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "expressCompany",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.expressCompany"
                                      }
                                    },
                                    _vm._l(
                                      _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.chineseName,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.fbaJob.destinationDistribution &&
                          Number(_vm.fbaJob.destinationDistribution) === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.CourierNumber")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "expressNo" },
                                    model: {
                                      value: _vm.fbaJob.expressNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fbaJob, "expressNo", $$v)
                                      },
                                      expression: "fbaJob.expressNo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.POOriginalOrderNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "poNumber" },
                                model: {
                                  value: _vm.fbaJob.poNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "poNumber", $$v)
                                  },
                                  expression: "fbaJob.poNumber"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Shipment Id" } },
                            [
                              _c("el-input", {
                                attrs: { no: "shipmentId" },
                                model: {
                                  value: _vm.fbaJob.shipmentId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "shipmentId", $$v)
                                  },
                                  expression: "fbaJob.shipmentId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Reference Id" } },
                            [
                              _c("el-input", {
                                attrs: { no: "referenceId" },
                                model: {
                                  value: _vm.fbaJob.referenceId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "referenceId", $$v)
                                  },
                                  expression: "fbaJob.referenceId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.EORIBusinessNumber")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "eoriNo" },
                                model: {
                                  value: _vm.fbaJob.eoriNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "eoriNo", $$v)
                                  },
                                  expression: "fbaJob.eoriNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("AirExport.VATTaxNumber") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "vatNo" },
                                model: {
                                  value: _vm.fbaJob.vatNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "vatNo", $$v)
                                  },
                                  expression: "fbaJob.vatNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.VATRegistrationCountry"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "taxRegisterCountry",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Country,
                                  filterable: "",
                                  "callback-params": {
                                    key: "taxRegisterCountry"
                                  },
                                  "callback-method-type": "value",
                                  "default-value": _vm.fbaJob.taxRegisterCountry
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.taxRegisterCountry = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.VATRegistrationAddress"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "taxRegisterAddress" },
                                model: {
                                  value: _vm.fbaJob.taxRegisterAddress,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "taxRegisterAddress",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.taxRegisterAddress"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.VATCompanyEnglishName")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "taxCompany" },
                                model: {
                                  value: _vm.fbaJob.taxCompany,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "taxCompany", $$v)
                                  },
                                  expression: "fbaJob.taxCompany"
                                }
                              })
                            ],
                            1
                          ),
                          _c("hr", {
                            staticStyle: {
                              "margin-top": "20px",
                              "margin-bottom": "20px"
                            }
                          }),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.PODDeliveryInformation"))
                            )
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.DeliveryToWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estWarehouseDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estWarehouseDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "estWarehouseDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.estWarehouseDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.DeliveryToWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.ActualDeliveryToWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actWarehouseDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actWarehouseDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "actWarehouseDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.actWarehouseDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estGoodsDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estGoodsDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "estGoodsDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.estGoodsDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actGoodsDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actGoodsDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "actGoodsDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.actGoodsDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.EstimatedDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "estDeliveryTime", $$v)
                                  },
                                  expression: "job.estDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.ActualDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "actDeliveryTime", $$v)
                                  },
                                  expression: "job.actDeliveryTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField1") } },
                    [
                      _c("el-input", {
                        attrs: { no: "86", type: "textarea", rows: 5 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField1"),
                              _vm.job.userDefinedField1,
                              function(val) {
                                _vm.job.userDefinedField1 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField1", $$v)
                          },
                          expression: "job.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField2") } },
                    [
                      _c("el-input", {
                        attrs: { no: "87", type: "textarea", rows: 5 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField2"),
                              _vm.job.userDefinedField2,
                              function(val) {
                                _vm.job.userDefinedField2 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField2", $$v)
                          },
                          expression: "job.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField3") } },
                    [
                      _c("el-input", {
                        attrs: { no: "88", type: "textarea", rows: 5 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField3"),
                              _vm.job.userDefinedField3,
                              function(val) {
                                _vm.job.userDefinedField3 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField3", $$v)
                          },
                          expression: "job.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField4") } },
                    [
                      _c("el-input", {
                        attrs: { no: "89", type: "textarea", rows: 5 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.UserDefinedField4"),
                              _vm.job.userDefinedField4,
                              function(val) {
                                _vm.job.userDefinedField4 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField4", $$v)
                          },
                          expression: "job.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxNature", $$v)
                            },
                            expression: "job.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticStyle: { "flex-direction": "column" } }, [
              _c("div", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "goods-info" },
                  [
                    _c("el-form-item", { staticClass: "auto-width" }, [
                      _c(
                        "div",
                        {
                          staticClass: "title-row",
                          staticStyle: { display: "flex", "text-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Weight")) +
                                  _vm._s(_vm.openImperial ? "LB" : "KGS")
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Cubage")) +
                                  _vm._s(_vm.openImperial ? "CFT" : "CBM")
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                  _vm._s(_vm.openImperial ? "LB" : "KGS")
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.Density")) + "kg/m³"
                              )
                            ]
                          ),
                          _vm.isFba
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.VolumetricWeight")
                                    ) + "KGS"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Size")) + "CM")]
                          ),
                          _vm.showImperialButton && _vm.viewStatus
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ImperialUnits")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.isOpenImperial
                                        ? "el-switch is-checked"
                                        : "el-switch"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "el-switch__core",
                                        staticStyle: { width: "40px" },
                                        on: {
                                          click: function($event) {
                                            _vm.isOpenImperial = !_vm.isOpenImperial
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "goods-info-item",
                        attrs: { label: _vm.$t("SeaExport.Consignation") }
                      },
                      [
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.quantityContract
                            ? "red-border"
                            : "",
                          attrs: { no: "90", precision: 0, min: 0 },
                          on: {
                            change: function($event) {
                              return _vm.calcEstVolumetricAndChargeWeight(false)
                            }
                          },
                          model: {
                            value: _vm.job.quantityContract,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantityContract", $$v)
                            },
                            expression: "job.quantityContract"
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightContract
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "weightContractImperial",
                                precision: 2,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.weightContractImperialChange()
                                }
                              },
                              model: {
                                value: _vm.job.weightContractImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "weightContractImperial",
                                    $$v
                                  )
                                },
                                expression: "job.weightContractImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageContract
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "cubAgeContractImperial",
                                precision: 3,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.cubAgeContractImperialChange()
                                }
                              },
                              model: {
                                value: _vm.job.cubAgeContractImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "cubAgeContractImperial",
                                    $$v
                                  )
                                },
                                expression: "job.cubAgeContractImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.chargeWeight
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "chargeWeightImperial",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.job.chargeWeightImperial,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "chargeWeightImperial", $$v)
                                },
                                expression: "job.chargeWeightImperial"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightContract
                                ? "red-border"
                                : "",
                              attrs: { no: "91", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.weightContractChange(true)
                                  _vm.calcEstVolumetricAndChargeWeight(false)
                                }
                              },
                              model: {
                                value: _vm.job.weightContract,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightContract", $$v)
                                },
                                expression: "job.weightContract"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageContract
                                ? "red-border"
                                : "",
                              attrs: { no: "92", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.cubageContractChange(true)
                                  _vm.calcEstVolumetricAndChargeWeight(false)
                                }
                              },
                              model: {
                                value: _vm.job.cubageContract,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageContract", $$v)
                                },
                                expression: "job.cubageContract"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.chargeWeight
                                ? "red-border"
                                : "",
                              attrs: { no: "93", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  return _vm.pm.chargeWeightImperialChange(
                                    "chargeWeight",
                                    "chargeWeightImperial"
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.chargeWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "chargeWeight", $$v)
                                },
                                expression: "job.chargeWeight"
                              }
                            })
                          ],
                          1
                        ),
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.densityContract
                            ? "red-border"
                            : "",
                          attrs: { precision: 3, min: 0, no: "140" },
                          model: {
                            value: _vm.job.densityContract,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "densityContract", $$v)
                            },
                            expression: "job.densityContract"
                          }
                        }),
                        _vm.isFba
                          ? _c("auto-number-input", {
                              attrs: {
                                no: "80",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.calcEstVolumetricAndChargeWeight(
                                    false,
                                    _vm.job.volumetricWeightContract
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.volumetricWeightContract,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "volumetricWeightContract",
                                    $$v
                                  )
                                },
                                expression: "job.volumetricWeightContract"
                              }
                            })
                          : _vm._e(),
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "padding-right": "5px"
                          },
                          attrs: { no: "commissionDimensions" },
                          model: {
                            value: _vm.job.commissionDimensions,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "commissionDimensions", $$v)
                            },
                            expression: "job.commissionDimensions"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "goods-info-item",
                        attrs: { label: _vm.$t("SeaExport.Booking") }
                      },
                      [
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.quantityBooking
                            ? "red-border"
                            : "",
                          attrs: { no: "94", precision: 0, min: 0 },
                          on: {
                            change: function($event) {
                              _vm.pm.weightCubageChangeHandler(
                                "quantityBooking"
                              )
                              _vm.calcEstVolumetricAndChargeWeight(true)
                            }
                          },
                          model: {
                            value: _vm.job.quantityBooking,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantityBooking", $$v)
                            },
                            expression: "job.quantityBooking"
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightBooking
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "weightBookingImperial",
                                precision: 2,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.weightCubAgeImperialChangeHandler(
                                    "weightBooking"
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.weightBookingImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "weightBookingImperial",
                                    $$v
                                  )
                                },
                                expression: "job.weightBookingImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageBooking
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "cubAgeBookingImperial",
                                precision: 3,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.weightCubAgeImperialChangeHandler(
                                    "cubageBooking"
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.cubAgeBookingImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "cubAgeBookingImperial",
                                    $$v
                                  )
                                },
                                expression: "job.cubAgeBookingImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField
                                .chargeWeightBooking
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "chargeWeightBookingImperial",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.job.chargeWeightBookingImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "chargeWeightBookingImperial",
                                    $$v
                                  )
                                },
                                expression: "job.chargeWeightBookingImperial"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightBooking
                                ? "red-border"
                                : "",
                              attrs: { no: "95", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.pm.doWeightCubAgeChangeHandler(
                                    "weightBooking"
                                  )
                                  _vm.calcEstVolumetricAndChargeWeight(true)
                                }
                              },
                              model: {
                                value: _vm.job.weightBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightBooking", $$v)
                                },
                                expression: "job.weightBooking"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageBooking
                                ? "red-border"
                                : "",
                              attrs: { no: "96", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.pm.doWeightCubAgeChangeHandler(
                                    "cubageBooking"
                                  )
                                  _vm.calcEstVolumetricAndChargeWeight(true)
                                }
                              },
                              model: {
                                value: _vm.job.cubageBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageBooking", $$v)
                                },
                                expression: "job.cubageBooking"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField
                                .chargeWeightBooking
                                ? "red-border"
                                : "",
                              attrs: { no: "97", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  return _vm.pm.chargeWeightImperialChange(
                                    "chargeWeightBooking",
                                    "chargeWeightBookingImperial"
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.chargeWeightBooking,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "chargeWeightBooking", $$v)
                                },
                                expression: "job.chargeWeightBooking"
                              }
                            })
                          ],
                          1
                        ),
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.densityBooking
                            ? "red-border"
                            : "",
                          attrs: { precision: 3, min: 0, no: "141" },
                          model: {
                            value: _vm.job.densityBooking,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "densityBooking", $$v)
                            },
                            expression: "job.densityBooking"
                          }
                        }),
                        _vm.isFba
                          ? _c("auto-number-input", {
                              attrs: {
                                no: "81",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.calcEstVolumetricAndChargeWeight(
                                    true,
                                    _vm.job.volumetricWeightBooking
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.volumetricWeightBooking,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "volumetricWeightBooking",
                                    $$v
                                  )
                                },
                                expression: "job.volumetricWeightBooking"
                              }
                            })
                          : _vm._e(),
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "padding-right": "5px"
                          },
                          attrs: { no: "measurements" },
                          on: {
                            input: function($event) {
                              return _vm.pm.weightCubageChangeHandler(
                                "measurements"
                              )
                            }
                          },
                          model: {
                            value: _vm.job.measurements,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "measurements", $$v)
                            },
                            expression: "job.measurements"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "goods-info-item",
                        attrs: { label: _vm.$t("SeaExport.FrontCabinActual") }
                      },
                      [
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.quantityActual
                            ? "red-border"
                            : "",
                          attrs: { no: "98", precision: 0, min: 0 },
                          on: {
                            change: function($event) {
                              _vm.pm.weightCubageChangeHandler("quantityActual")
                              _vm.quantityActualChange()
                            }
                          },
                          model: {
                            value: _vm.job.quantityActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantityActual", $$v)
                            },
                            expression: "job.quantityActual"
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightActual
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "weightActualImperial",
                                precision: 2,
                                min: 0
                              },
                              on: { change: _vm.weightActualImperialChange },
                              model: {
                                value: _vm.job.weightActualImperial,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightActualImperial", $$v)
                                },
                                expression: "job.weightActualImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageActual
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "cubAgeActualImperial",
                                precision: 3,
                                min: 0
                              },
                              on: { change: _vm.cubAgeActualImperialChange },
                              model: {
                                value: _vm.job.cubAgeActualImperial,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubAgeActualImperial", $$v)
                                },
                                expression: "job.cubAgeActualImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cWeight
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "cWeightImperial",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.job.cWeightImperial,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cWeightImperial", $$v)
                                },
                                expression: "job.cWeightImperial"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightActual
                                ? "red-border"
                                : "",
                              attrs: { no: "99", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  return _vm.weightActualChange(true)
                                }
                              },
                              model: {
                                value: _vm.job.weightActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightActual", $$v)
                                },
                                expression: "job.weightActual"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageActual
                                ? "red-border"
                                : "",
                              attrs: { no: "100", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  return _vm.cubageActualChange(true)
                                }
                              },
                              model: {
                                value: _vm.job.cubageActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageActual", $$v)
                                },
                                expression: "job.cubageActual"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cWeight
                                ? "red-border"
                                : "",
                              attrs: { no: "101", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.isFba
                                    ? _vm.changeChargeWeight
                                    : _vm.pm.weightCubageChangeHandler(
                                        "chargeWeightActual"
                                      )
                                }
                              },
                              model: {
                                value: _vm.job.cWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cWeight", $$v)
                                },
                                expression: "job.cWeight"
                              }
                            })
                          ],
                          1
                        ),
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.densityActual
                            ? "red-border"
                            : "",
                          attrs: { precision: 3, min: 0, no: "142" },
                          model: {
                            value: _vm.job.densityActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "densityActual", $$v)
                            },
                            expression: "job.densityActual"
                          }
                        }),
                        _vm.isFba
                          ? _c("auto-number-input", {
                              attrs: {
                                no: "82",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: { change: _vm.changeVolumetricWeight },
                              model: {
                                value: _vm.job.volumetricWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "volumetricWeight", $$v)
                                },
                                expression: "job.volumetricWeight"
                              }
                            })
                          : _vm._e(),
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "padding-right": "5px"
                          },
                          attrs: { no: "dimensionsActual" },
                          on: {
                            input: function($event) {
                              return _vm.pm.weightCubageChangeHandler(
                                "dimensionsActual"
                              )
                            }
                          },
                          model: {
                            value: _vm.job.dimensionsActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dimensionsActual", $$v)
                            },
                            expression: "job.dimensionsActual"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "goods-info-item",
                        attrs: { label: _vm.$t("SeaExport.FreightStation") }
                      },
                      [
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.quantityStation
                            ? "red-border"
                            : "",
                          attrs: { no: "150", precision: 0, min: 0 },
                          on: {
                            change: function($event) {
                              _vm.pm.weightCubageChangeHandler(
                                "quantityStation"
                              )
                              _vm.calcStationVolumetricAndChargeWeight()
                            }
                          },
                          model: {
                            value: _vm.job.quantityStation,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantityStation", $$v)
                            },
                            expression: "job.quantityStation"
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightStation
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "weightStationImperial",
                                precision: 2,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.weightStationImperialChange()
                                }
                              },
                              model: {
                                value: _vm.job.weightStationImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "weightStationImperial",
                                    $$v
                                  )
                                },
                                expression: "job.weightStationImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageStation
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "cubAgeStationImperial",
                                precision: 3,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.cubAgeStationImperialChange()
                                }
                              },
                              model: {
                                value: _vm.job.cubAgeStationImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "cubAgeStationImperial",
                                    $$v
                                  )
                                },
                                expression: "job.cubAgeStationImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              attrs: {
                                no: "chargeWeightStationImperial",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.job.chargeWeightStationImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "chargeWeightStationImperial",
                                    $$v
                                  )
                                },
                                expression: "job.chargeWeightStationImperial"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightStation
                                ? "red-border"
                                : "",
                              attrs: { no: "151", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.weightStationChange(true)
                                  _vm.calcStationVolumetricAndChargeWeight()
                                }
                              },
                              model: {
                                value: _vm.job.weightStation,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightStation", $$v)
                                },
                                expression: "job.weightStation"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageStation
                                ? "red-border"
                                : "",
                              attrs: { no: "152", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.cubageStationChange(true)
                                  _vm.calcStationVolumetricAndChargeWeight()
                                }
                              },
                              model: {
                                value: _vm.job.cubageStation,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageStation", $$v)
                                },
                                expression: "job.cubageStation"
                              }
                            }),
                            _c("auto-number-input", {
                              attrs: { no: "153", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  return _vm.pm.chargeWeightImperialChange(
                                    "chargeWeightStation",
                                    "chargeWeightStationImperial"
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.chargeWeightStation,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "chargeWeightStation", $$v)
                                },
                                expression: "job.chargeWeightStation"
                              }
                            })
                          ],
                          1
                        ),
                        _c("auto-number-input", {
                          attrs: { precision: 3, min: 0, no: "154" },
                          model: {
                            value: _vm.job.densityStation,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "densityStation", $$v)
                            },
                            expression: "job.densityStation"
                          }
                        }),
                        _vm.isFba
                          ? _c("auto-number-input", {
                              attrs: {
                                no: "155",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.calcStationVolumetricAndChargeWeight(
                                    _vm.job.volumetricWeightStation
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.volumetricWeightStation,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "volumetricWeightStation",
                                    $$v
                                  )
                                },
                                expression: "job.volumetricWeightStation"
                              }
                            })
                          : _vm._e(),
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "padding-right": "5px"
                          },
                          attrs: { no: "freightStationDimensions" },
                          on: {
                            input: function($event) {
                              return _vm.pm.weightCubageChangeHandler(
                                "freightStationDimensions"
                              )
                            }
                          },
                          model: {
                            value: _vm.job.freightStationDimensions,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "freightStationDimensions", $$v)
                            },
                            expression: "job.freightStationDimensions"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "goods-info-item",
                        attrs: { label: _vm.$t("SeaExport.SignBill") }
                      },
                      [
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.quantitySigning
                            ? "red-border"
                            : "",
                          attrs: { no: "156", precision: 0, min: 0 },
                          on: {
                            change: function($event) {
                              _vm.pm.weightCubageChangeHandler(
                                "quantitySigning"
                              )
                              _vm.calcSigningVolumetricAndChargeWeight()
                            }
                          },
                          model: {
                            value: _vm.job.quantitySigning,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantitySigning", $$v)
                            },
                            expression: "job.quantitySigning"
                          }
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightSigning
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "weightSigningImperial",
                                precision: 2,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.weightSigningImperialChange()
                                }
                              },
                              model: {
                                value: _vm.job.weightSigningImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "weightSigningImperial",
                                    $$v
                                  )
                                },
                                expression: "job.weightSigningImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageSigning
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "cubAgeSigningImperial",
                                precision: 3,
                                min: 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.cubAgeSigningImperialChange()
                                }
                              },
                              model: {
                                value: _vm.job.cubAgeSigningImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "cubAgeSigningImperial",
                                    $$v
                                  )
                                },
                                expression: "job.cubAgeSigningImperial"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField
                                .chargeWeightSigning
                                ? "red-border"
                                : "",
                              attrs: {
                                no: "chargeWeightSigningImperial",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              model: {
                                value: _vm.job.chargeWeightSigningImperial,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "chargeWeightSigningImperial",
                                    $$v
                                  )
                                },
                                expression: "job.chargeWeightSigningImperial"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ]
                          },
                          [
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.weightSigning
                                ? "red-border"
                                : "",
                              attrs: { no: "157", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.weightSigningChange(true)
                                  _vm.calcSigningVolumetricAndChargeWeight()
                                }
                              },
                              model: {
                                value: _vm.job.weightSigning,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightSigning", $$v)
                                },
                                expression: "job.weightSigning"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.cubageSigning
                                ? "red-border"
                                : "",
                              attrs: { no: "158", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.cubageSigningChange(true)
                                  _vm.calcSigningVolumetricAndChargeWeight()
                                }
                              },
                              model: {
                                value: _vm.job.cubageSigning,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageSigning", $$v)
                                },
                                expression: "job.cubageSigning"
                              }
                            }),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField
                                .chargeWeightSigning
                                ? "red-border"
                                : "",
                              attrs: { no: "159", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  return _vm.pm.chargeWeightImperialChange(
                                    "chargeWeightSigning",
                                    "chargeWeightSigningImperial"
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.chargeWeightSigning,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "chargeWeightSigning", $$v)
                                },
                                expression: "job.chargeWeightSigning"
                              }
                            })
                          ],
                          1
                        ),
                        _c("auto-number-input", {
                          class: _vm.importDifferenceField.densitySigning
                            ? "red-border"
                            : "",
                          attrs: { precision: 3, min: 0, no: "160" },
                          model: {
                            value: _vm.job.densitySigning,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "densitySigning", $$v)
                            },
                            expression: "job.densitySigning"
                          }
                        }),
                        _vm.isFba
                          ? _c("auto-number-input", {
                              attrs: {
                                no: "161",
                                precision: 3,
                                min: 0,
                                disabled: true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.calcSigningVolumetricAndChargeWeight(
                                    _vm.job.volumetricWeightSigning
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.volumetricWeightSigning,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "volumetricWeightSigning",
                                    $$v
                                  )
                                },
                                expression: "job.volumetricWeightSigning"
                              }
                            })
                          : _vm._e(),
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "padding-right": "5px"
                          },
                          attrs: { no: "dimensionsSigning" },
                          on: {
                            input: function($event) {
                              return _vm.pm.weightCubageChangeHandler(
                                "dimensionsSigning"
                              )
                            }
                          },
                          model: {
                            value: _vm.job.dimensionsSigning,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dimensionsSigning", $$v)
                            },
                            expression: "job.dimensionsSigning"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.job.operateType !== 0
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "goods-info-item",
                            attrs: { label: _vm.$t("SeaExport.Documentation") }
                          },
                          [
                            _c("auto-number-input", {
                              attrs: { no: "102", precision: 0, min: 0 },
                              on: {
                                change: function($event) {
                                  _vm.pm.weightCubageChangeHandler(
                                    "quantityMBL"
                                  )
                                  _vm.calcActVolumetricAndChargeWeight(true)
                                }
                              },
                              model: {
                                value: _vm.mawbDoc.quantity,
                                callback: function($$v) {
                                  _vm.$set(_vm.mawbDoc, "quantity", $$v)
                                },
                                expression: "mawbDoc.quantity"
                              }
                            }),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.openImperial,
                                    expression: "openImperial"
                                  }
                                ]
                              },
                              [
                                _c("auto-number-input", {
                                  attrs: {
                                    no: "weightImperial",
                                    precision: 2,
                                    min: 0
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.pm.weightCubAgeImperialChangeHandler(
                                        "weightMBL"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.mawbDoc.weightImperial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mawbDoc,
                                        "weightImperial",
                                        $$v
                                      )
                                    },
                                    expression: "mawbDoc.weightImperial"
                                  }
                                }),
                                _c("auto-number-input", {
                                  attrs: {
                                    no: "cubAgeImperial",
                                    precision: 3,
                                    min: 0
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.pm.weightCubAgeImperialChangeHandler(
                                        "cubageMBL"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.mawbDoc.cubAgeImperial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mawbDoc,
                                        "cubAgeImperial",
                                        $$v
                                      )
                                    },
                                    expression: "mawbDoc.cubAgeImperial"
                                  }
                                }),
                                _c("auto-number-input", {
                                  attrs: {
                                    no: "chargeWeightImperial",
                                    precision: 3,
                                    min: 0,
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.mawbDoc.chargeWeightImperial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mawbDoc,
                                        "chargeWeightImperial",
                                        $$v
                                      )
                                    },
                                    expression: "mawbDoc.chargeWeightImperial"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.openImperial,
                                    expression: "!openImperial"
                                  }
                                ]
                              },
                              [
                                _c("auto-number-input", {
                                  attrs: { no: "103", precision: 3, min: 0 },
                                  on: {
                                    change: function($event) {
                                      _vm.pm.doWeightCubAgeChangeHandler(
                                        "weightMBL"
                                      )
                                      _vm.calcActVolumetricAndChargeWeight(true)
                                    }
                                  },
                                  model: {
                                    value: _vm.mawbDoc.weight,
                                    callback: function($$v) {
                                      _vm.$set(_vm.mawbDoc, "weight", $$v)
                                    },
                                    expression: "mawbDoc.weight"
                                  }
                                }),
                                _c("auto-number-input", {
                                  attrs: { no: "104", precision: 3, min: 0 },
                                  on: {
                                    change: function($event) {
                                      _vm.pm.doWeightCubAgeChangeHandler(
                                        "cubageMBL"
                                      )
                                      _vm.calcActVolumetricAndChargeWeight(true)
                                    }
                                  },
                                  model: {
                                    value: _vm.mawbDoc.cubage,
                                    callback: function($$v) {
                                      _vm.$set(_vm.mawbDoc, "cubage", $$v)
                                    },
                                    expression: "mawbDoc.cubage"
                                  }
                                }),
                                _c("auto-number-input", {
                                  attrs: { no: "105", precision: 3, min: 0 },
                                  on: {
                                    change: function($event) {
                                      return _vm.pm.doWeightCubAgeChangeHandler(
                                        "chargeWeightMBL"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.mawbDoc.cWeight,
                                    callback: function($$v) {
                                      _vm.$set(_vm.mawbDoc, "cWeight", $$v)
                                    },
                                    expression: "mawbDoc.cWeight"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("auto-number-input", {
                              class: _vm.importDifferenceField.densityDoc
                                ? "red-border"
                                : "",
                              attrs: { precision: 3, min: 0, no: "143" },
                              model: {
                                value: _vm.job.densityDoc,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "densityDoc", $$v)
                                },
                                expression: "job.densityDoc"
                              }
                            }),
                            _vm.isFba
                              ? _c("auto-number-input", {
                                  attrs: {
                                    no: "82",
                                    precision: 3,
                                    min: 0,
                                    disabled: true
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.calcActVolumetricAndChargeWeight(
                                        true,
                                        _vm.mawbDoc.volumetricWeight
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.mawbDoc.volumetricWeight,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mawbDoc,
                                        "volumetricWeight",
                                        $$v
                                      )
                                    },
                                    expression: "mawbDoc.volumetricWeight"
                                  }
                                })
                              : _vm._e(),
                            _c("el-input", {
                              staticStyle: {
                                width: "200px",
                                "padding-right": "5px"
                              },
                              attrs: { no: "docDimensions" },
                              model: {
                                value: _vm.job.docDimensions,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "docDimensions", $$v)
                                },
                                expression: "job.docDimensions"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isFba
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "text-align": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.Package"),
                                  "label-width": "100px"
                                }
                              },
                              [
                                _c("cargo-packing-select", {
                                  class: _vm.importDifferenceField.packing
                                    ? "red-border"
                                    : "",
                                  staticStyle: {
                                    "margin-left": "12px",
                                    width: "190px"
                                  },
                                  attrs: {
                                    no: "106",
                                    "default-value": _vm.job.packing,
                                    "callback-params": {},
                                    placeholder: " "
                                  },
                                  on: {
                                    change: function(p) {
                                      p.key = "packing"
                                      _vm.setJobSelectValue(p)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.CustomersCollectByBubble"
                                  ),
                                  "label-width": "95px"
                                }
                              },
                              [
                                _vm.splitBubbleCollectionFormat
                                  ? _c(
                                      "el-select",
                                      {
                                        class: _vm.importDifferenceField
                                          .pbProportion
                                          ? "red-border"
                                          : "",
                                        attrs: {
                                          value: _vm.job.pbProportion || "",
                                          no: "107",
                                          clearable: "",
                                          filterable: !_vm.pbProportionCheck,
                                          "allow-create": !_vm.pbProportionCheck
                                        },
                                        on: {
                                          focus: _vm.onPbProportionFocus,
                                          input: function(val) {
                                            _vm.job.pbProportion = val
                                          },
                                          change: function($event) {
                                            return _vm.pm.weightCubageChangeHandler(
                                              "pbProportion"
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(
                                        _vm.SPLIT_BUBBLE_COLLECT_ITEMS,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: _vm.$getLangColumn(item),
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : [
                                      _c("el-input-number", {
                                        staticStyle: { width: "95px" },
                                        attrs: {
                                          no: "107",
                                          "controls-position": "right",
                                          min: 0,
                                          max: 999999999
                                        },
                                        on: {
                                          input: function(val) {
                                            _vm.job.pbProportion
                                          },
                                          change: function($event) {
                                            return _vm.pm.weightCubageChangeHandler(
                                              "pbProportion"
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.job.pbProportion,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "pbProportion",
                                              $$v
                                            )
                                          },
                                          expression: "job.pbProportion"
                                        }
                                      }),
                                      _c("span", [_vm._v("%")])
                                    ]
                              ],
                              2
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "10px" },
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.CollectionBySupplier"
                                  ),
                                  "label-width": "100px"
                                }
                              },
                              [
                                _vm.splitBubbleCollectionFormat
                                  ? _c(
                                      "el-select",
                                      {
                                        class: _vm.importDifferenceField
                                          .pbProportion2
                                          ? "red-border"
                                          : "",
                                        attrs: {
                                          value: _vm.job.pbProportion2 || "",
                                          no: "108",
                                          clearable: "",
                                          filterable: !_vm.pbProportion2Check,
                                          "allow-create": !_vm.pbProportion2Check
                                        },
                                        on: {
                                          focus: _vm.onPbProportion2Focus,
                                          input: function(val) {
                                            _vm.job.pbProportion2 = val
                                          },
                                          change: function($event) {
                                            return _vm.pm.weightCubageChangeHandler(
                                              "pbProportion2"
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(
                                        _vm.SPLIT_BUBBLE_COLLECT_ITEMS,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: _vm.$getLangColumn(item),
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : [
                                      _c("el-input-number", {
                                        staticStyle: { width: "85px" },
                                        attrs: {
                                          no: "108",
                                          "controls-position": "right",
                                          min: 0,
                                          max: 999999999
                                        },
                                        on: {
                                          input: function(val) {
                                            _vm.job.pbProportion2
                                          },
                                          change: function($event) {
                                            return _vm.pm.weightCubageChangeHandler(
                                              "pbProportion2"
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.job.pbProportion2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "pbProportion2",
                                              $$v
                                            )
                                          },
                                          expression: "job.pbProportion2"
                                        }
                                      }),
                                      _c("span", [_vm._v("%")])
                                    ]
                              ],
                              2
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "10px" },
                                attrs: {
                                  label: _vm.$t("SeaExport.Slac"),
                                  "label-width": "100px"
                                }
                              },
                              [
                                _c("el-input-number", {
                                  class: _vm.importDifferenceField.slac
                                    ? "red-border"
                                    : "",
                                  staticStyle: { width: "85px" },
                                  attrs: {
                                    no: "slac",
                                    min: 0,
                                    precision: 0,
                                    controls: false
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.pm.slacChangeHandler(p)
                                    }
                                  },
                                  model: {
                                    value: _vm.job.slac,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "slac", $$v)
                                    },
                                    expression: "job.slac"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("el-form-item")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.isFba
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "text-align": "left",
                          "margin-left": "20px"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { "label-width": "80px" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "blue",
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FbaJob.ChargingMethod")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { no: "chargingMethod" },
                                        on: {
                                          change: _vm.chargingMethodChange
                                        },
                                        model: {
                                          value: _vm.fbaJob.chargingMethod,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fbaJob,
                                              "chargingMethod",
                                              $$v
                                            )
                                          },
                                          expression: "fbaJob.chargingMethod"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v(_vm._s("KG"))]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v(_vm._s("CBM"))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.pbProportion"),
                                      "label-width": "80px"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("el-input", {
                                          attrs: { no: "bubbleSplittingRatio" },
                                          on: {
                                            change:
                                              _vm.bubbleSplittingRatioChange
                                          },
                                          model: {
                                            value:
                                              _vm.fbaJob.bubbleSplittingRatio,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.fbaJob,
                                                "bubbleSplittingRatio",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "fbaJob.bubbleSplittingRatio"
                                          }
                                        }),
                                        _vm._v("% ")
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.pbProportion2"),
                                      "label-width": "80px"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "90px" },
                                          attrs: {
                                            no: "108",
                                            "controls-position": "right",
                                            min: 0,
                                            max: 999999999
                                          },
                                          on: {
                                            input: function(val) {
                                              _vm.job.pbProportion2
                                            },
                                            change: function($event) {
                                              return _vm.pm.weightCubageChangeHandler(
                                                "pbProportion2"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.job.pbProportion2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.job,
                                                "pbProportion2",
                                                $$v
                                              )
                                            },
                                            expression: "job.pbProportion2"
                                          }
                                        }),
                                        _c("span", [_vm._v("%")])
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _vm.isFba
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "FbaChannel.bubbleCountingRatio"
                                          ),
                                          "label-width": "80px"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { no: "bubbleCountingRatio" },
                                          on: {
                                            change: _vm.bubbleCountingChange
                                          },
                                          model: {
                                            value:
                                              _vm.fbaJob.bubbleCountingRatio,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.fbaJob,
                                                "bubbleCountingRatio",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "fbaJob.bubbleCountingRatio"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "section form-row" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      width: "1200px",
                      "max-width": "100%"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        staticStyle: { width: "290px" },
                        attrs: {
                          label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          class:
                            _vm.job.cargoEnglishNameWarning === 1
                              ? "red-border"
                              : "",
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "110",
                            "text-chars": 0,
                            "warning-count": 45,
                            disabled: _vm.viewStatus,
                            "english-letter-auto-uppercase":
                              _vm.isUppercaseByConfig
                          },
                          on: {
                            blur: function($event) {
                              return _vm.pm.cargoEnglishNameBlurHandler()
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                _vm.job.cargoEnglishName,
                                function(val) {
                                  _vm.pm.cargoEnglishNameChangeHandler(val)
                                },
                                _vm.isUppercaseByConfig,
                                { warningCount: 45, maxChar: 0 }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoEnglishName", $$v)
                            },
                            expression: "job.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        staticStyle: { width: "290px" },
                        attrs: { label: _vm.$t("SeaExport.Marks") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "111",
                            "text-chars": 0,
                            "warning-count": 45,
                            disabled: _vm.viewStatus,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          on: {
                            blur: function($event) {
                              return _vm.pm.markBlurHandler()
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Marks"),
                                _vm.job.mark,
                                function(val) {
                                  _vm.pm.markChangeHandler(val)
                                },
                                _vm.isUppercaseByConfig,
                                { warningCount: 45, maxChar: 0 }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "mark", $$v)
                            },
                            expression: "job.mark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        staticStyle: { width: "290px" },
                        attrs: {
                          label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          class:
                            _vm.job.cargoChineseNameWarning === 1
                              ? "red-border"
                              : "",
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "112",
                            "text-chars": 0,
                            "warning-count": -1,
                            disabled: _vm.viewStatus,
                            "auto-uppercase": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                _vm.job.cargoChineseName,
                                function(val) {
                                  _vm.job.cargoChineseName = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoChineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoChineseName", $$v)
                            },
                            expression: "job.cargoChineseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        staticStyle: { width: "290px" },
                        attrs: {
                          label: _vm.$t("SeaExport.specialOperationCode")
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.job.specialOperationCode,
                              placement: "left"
                            }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.job.specialOperationCode ||
                                    _vm.$t("SeaExport.NoData")
                                )
                              },
                              slot: "content"
                            }),
                            _c("el-input", {
                              staticStyle: { height: "110px" },
                              attrs: {
                                no: "1211",
                                value: _vm.job.specialOperationCode,
                                placeholder: _vm.viewStatus
                                  ? ""
                                  : _vm.$t(
                                      "SeaExport.doubleClickToAddSpecialOperationCode"
                                    ),
                                rows: 6,
                                type: "textarea"
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.selectSpecialOperationCodeDialog.value =
                                    _vm.job.specialOperationCode
                                  _vm.selectSpecialOperationCodeDialog.visible = !_vm.viewStatus
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "section", staticStyle: { width: "100%" } },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.CustomerDeliveryInfo")))
                ]),
                _c(
                  "div",
                  [
                    !_vm.isFba
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "CodeSearching",
                              disabled: _vm.viewStatus,
                              type: "primary"
                            },
                            on: { click: _vm.codeSearch }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      : _vm._e(),
                    _vm.isFba
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              no: "FbaCodeSearching",
                              disabled: _vm.viewStatus,
                              type: "primary"
                            },
                            on: { click: _vm.fbaCodeSearchBtn }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      "margin-top": "8px"
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "50px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Shipper") }
                          },
                          [
                            _c("cargo-input", {
                              class: _vm.importDifferenceField.shipperCode
                                ? "red-border"
                                : "",
                              staticStyle: {
                                width: "110px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.viewStatus,
                                no: "shipperCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify
                              },
                              on: {
                                change: function(data) {
                                  _vm.pm.shipperCodeChange(data)
                                }
                              },
                              model: {
                                value: _vm.job.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "shipperCode", $$v)
                                },
                                expression: "job.shipperCode"
                              }
                            }),
                            _c("cargo-company-select", {
                              class: _vm.importDifferenceField.shipperId
                                ? "red-border"
                                : "",
                              staticStyle: {
                                display: "inline-block",
                                width: "135px"
                              },
                              attrs: {
                                no: "113",
                                disabled: _vm.viewStatus,
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value": _vm.job.shipperId || "",
                                fields: ["englishName"],
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                change: function(data) {
                                  _vm.pm.shipperChange(data)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(7, function(i) {
                          return _c(
                            "el-form-item",
                            { key: i, attrs: { "label-width": "0" } },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine" + i,
                                refInFor: true,
                                class: _vm.importDifferenceField[
                                  "shipperLine" + i
                                ]
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: _vm.viewStatus,
                                  no: "shipperLine" + i,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function() {
                                    return _vm.wrapAddr(
                                      _vm.job,
                                      "shipperLine" + i,
                                      i + 1 > 7
                                        ? null
                                        : "shipperLine" + (i + 1),
                                      200
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Shipper"),
                                      _vm.mergeShipperLine(),
                                      _vm.splitShipperLine,
                                      _vm.notUppercaseShipperConsigneNotify
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job["shipperLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine" + i, $$v)
                                  },
                                  expression: "job['shipperLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "20px" },
                        attrs: {
                          "label-width": "50px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Consignee") }
                          },
                          [
                            _c("cargo-input", {
                              class: _vm.importDifferenceField.consigneeCode
                                ? "red-border"
                                : "",
                              staticStyle: {
                                width: "110px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.viewStatus,
                                no: "consigneeCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify
                              },
                              on: {
                                change: function(data) {
                                  _vm.pm.consigneeCodeChange(data)
                                }
                              },
                              model: {
                                value: _vm.job.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "consigneeCode", $$v)
                                },
                                expression: "job.consigneeCode"
                              }
                            }),
                            _c("cargo-company-select", {
                              class: _vm.importDifferenceField.consigneeId
                                ? "red-border"
                                : "",
                              staticStyle: {
                                display: "inline-block",
                                width: "135px"
                              },
                              attrs: {
                                no: "115",
                                disabled: _vm.viewStatus,
                                "method-params": {
                                  consignee: true,
                                  active: true
                                },
                                "default-value": _vm.job.consigneeId || "",
                                fields: ["englishName"],
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                change: function(data) {
                                  _vm.pm.consigneeChange(data)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(7, function(i) {
                          return _c(
                            "el-form-item",
                            { key: i, attrs: { "label-width": "0" } },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine" + i,
                                refInFor: true,
                                class: _vm.importDifferenceField[
                                  "consigneeLine" + i
                                ]
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: _vm.viewStatus,
                                  no: "consigneeLine" + i,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function() {
                                    return _vm.wrapAddr(
                                      _vm.job,
                                      "consigneeLine" + i,
                                      i + 1 > 7
                                        ? null
                                        : "consigneeLine" + (i + 1),
                                      200
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Consignee"),
                                      _vm.mergeConsigneeLine(),
                                      _vm.splitConsigneeLine,
                                      _vm.notUppercaseShipperConsigneNotify
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job["consigneeLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                                  },
                                  expression: "job['consigneeLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "20px" },
                        attrs: {
                          "label-width": "50px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                          },
                          [
                            _c("cargo-input", {
                              class: _vm.importDifferenceField.notifyCode
                                ? "red-border"
                                : "",
                              staticStyle: {
                                width: "110px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.viewStatus,
                                no: "notifyCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify
                              },
                              on: {
                                change: function(data) {
                                  _vm.pm.notifyCodeChange(data)
                                }
                              },
                              model: {
                                value: _vm.job.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "notifyCode", $$v)
                                },
                                expression: "job.notifyCode"
                              }
                            }),
                            _c("cargo-company-select", {
                              class: _vm.importDifferenceField.notifyId
                                ? "red-border"
                                : "",
                              staticStyle: {
                                display: "inline-block",
                                width: "135px"
                              },
                              attrs: {
                                no: "117",
                                disabled: _vm.viewStatus,
                                "method-params": { notify: true, active: true },
                                "default-value": _vm.job.notifyId || "",
                                fields: ["englishName"],
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                change: function(data) {
                                  _vm.pm.notifyChange(data)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(7, function(i) {
                          return _c(
                            "el-form-item",
                            { key: i, attrs: { "label-width": "0" } },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine" + i,
                                refInFor: true,
                                class: _vm.importDifferenceField[
                                  "notifyLine" + i
                                ]
                                  ? "red-border"
                                  : "",
                                attrs: {
                                  disabled: _vm.viewStatus,
                                  no: "notifyLine" + i,
                                  "auto-uppercase":
                                    _vm.notUppercaseShipperConsigneNotify,
                                  "use-read-only": true
                                },
                                on: {
                                  change: function() {
                                    return _vm.wrapAddr(
                                      _vm.job,
                                      "notifyLine" + i,
                                      i + 1 > 7 ? null : "notifyLine" + (i + 1),
                                      200
                                    )
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.NotifyParty"),
                                      _vm.mergeNotifyLine(),
                                      _vm.splitNotifyLine,
                                      _vm.notUppercaseShipperConsigneNotify
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job["notifyLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "notifyLine" + i, $$v)
                                  },
                                  expression: "job['notifyLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "line-height": "28px",
                              "padding-bottom": "5px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.SecondNotifyParty"))
                            )
                          ]
                        ),
                        _c("cargo-rich-textarea", {
                          class: _vm.importDifferenceField.alsoNotify
                            ? "red-border"
                            : "",
                          staticStyle: { width: "310px", height: "200px" },
                          attrs: {
                            no: "119",
                            disabled: _vm.viewStatus,
                            "text-chars": 0
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.SecondNotifyParty"),
                                _vm.job.alsoNotify,
                                function(val) {
                                  _vm.job.alsoNotify = val
                                },
                                true,
                                { warningCount: 45, maxChar: 0 }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.alsoNotify,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "alsoNotify", $$v)
                            },
                            expression: "job.alsoNotify"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ]
      ),
      _vm.showContactsInfoDialog
        ? _c("cargo-contacts-info-dialog", {
            attrs: {
              visible: _vm.showContactsInfoDialog,
              "customer-id": _vm.job.customerId,
              "customer-contact": _vm.job.customerContact
            },
            on: {
              "update:visible": function($event) {
                _vm.showContactsInfoDialog = $event
              }
            }
          })
        : _vm._e(),
      _c("transit-port-dialog", {
        attrs: {
          visible: _vm.transitPortDialog.visible,
          job: _vm.transitPortDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transitPortDialog, "visible", $event)
          },
          enter: _vm.transitPortDialogCallback
        }
      }),
      _c("select-mawb-dialog", {
        attrs: {
          visible: _vm.selectMawbDialog.visible,
          type: _vm.selectMawbDialog.type,
          "operate-type": _vm.selectMawbDialog.operateType,
          "carrier-id": _vm.selectMawbDialog.carrierId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectMawbDialog, "visible", $event)
          },
          enterEvent: _vm.selectedMAWBHandler
        }
      }),
      _vm.selectOperationReqDialog.visible
        ? _c("select-operation-req-dialog", {
            attrs: {
              visible: _vm.selectOperationReqDialog.visible,
              lob: "AE",
              value: _vm.selectOperationReqDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
              },
              callback: function(val) {
                _vm.job.operationContent = val
                this$1.pm.syncDocHandlingInfo()
              }
            }
          })
        : _vm._e(),
      _vm.selectSpecialOperationCodeDialog.visible
        ? _c("select-special-operation-code-dialog", {
            attrs: {
              visible: _vm.selectSpecialOperationCodeDialog.visible,
              lob: "AE",
              value: _vm.selectSpecialOperationCodeDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.selectSpecialOperationCodeDialog,
                  "visible",
                  $event
                )
              },
              callback: function(val) {
                _vm.job.specialOperationCode = val
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.showDialog,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              no: "144"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.viewStatus,
                      expression: "!viewStatus"
                    }
                  ],
                  attrs: { no: "120", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "121" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sop-dialog", {
        attrs: {
          visible: _vm.sopDialog.visible,
          "cmp-idx": _vm.sopDialog.cmpIdx,
          job: _vm.job,
          agent: _vm.sopDialog.agent,
          lob: "AE",
          "contact-list": _vm.sopDialog.contactList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopDialog, "visible", $event)
          },
          updateJob: function($event) {
            return _vm.$emit("updateJob")
          }
        }
      }),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.billAddressDialog.job,
          params: _vm.billAddressDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("ware-house-dialog", {
        attrs: {
          visible: _vm.warehouseDialog.visible,
          job: _vm.warehouseDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseDialog, "visible", $event)
          },
          warehouseCommitCallback: _vm.warehouseCommitCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      }),
      _c("fba-bill-address-dialog", {
        attrs: { visible: _vm.fbaBillAddressDialog.visible, job: _vm.fbaJob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fbaBillAddressDialog, "visible", $event)
          },
          callback: _vm.fbaCodeSearchCallback
        }
      }),
      _vm.dimensionsDialog.visible
        ? _c("common-dimensions-dialog", {
            attrs: {
              visible: _vm.dimensionsDialog.visible,
              "open-imperial": _vm.openImperial
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.dimensionsDialog, "visible", $event)
              },
              sizeData: _vm.sizeDataHandler,
              close: function($event) {
                _vm.dimensionsDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }